import { IntlShape } from "react-intl";
import { BaseAction } from "../../../core/actions/BaseAction";
import { isActionRunSuccessfully, isEmpty } from "../../../Lib/Utils/validationUtil";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { IRetrieveForm } from "../../../Orchestrator/Types/Interface/IBookingTrip";
import { IRetrieveBooingActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/RetrieveBookingParams";
import { showNotification } from "../../../Services/notificationService";
import { retrieveBookingAPICallAction } from "./RetrieveBookingAPICallAction";
import { getTranslatedMessage } from "../../../Lib/Utils/i18n";

class RetrieveBookingAction extends BaseAction<IDefaultActionResult, IRetrieveBooingActionParams> {
    isFormValid = (retrieveForm: IRetrieveForm, intl: any) => {
        let isValid = true;
        const error = { ...retrieveForm.error };
        const listOfValueKeys = Object.keys(retrieveForm.value) as Array<
            keyof typeof retrieveForm.value
        >;
        const retrieveFormValue = { ...retrieveForm.value };
        listOfValueKeys.forEach((key) => {
            const trimmedValue = retrieveFormValue[key].trim();
            if (isEmpty(trimmedValue)) {
                error[key] = intl.formatMessage({ id: "fieldRequiredText" });
                isValid = false;
            } else {
                if (key === "bookingReference") {
                    const bookingReferenceRegex = /^[a-zA-Z0-9]+$/;
                    if (/\s/.test(retrieveFormValue[key])) {
                        error[key] = intl.formatMessage({ id: "bookingReferenceInvalidError" });
                        isValid = false;
                    } else if (!bookingReferenceRegex.test(trimmedValue)) {
                        error[key] = intl.formatMessage({ id: "bookingReferenceInvalidError" });
                        isValid = false;
                    }
                } else if (key === "lastName") {
                   const lastNameRegex = /^[\p{L}\p{M}\s'-]{1,50}$/u;

                    if (trimmedValue.length > 50) {
                        error[key] = intl.formatMessage({ id: "lastNameMaxLengthError" });
                        isValid = false;
                    } else if (!lastNameRegex.test(trimmedValue)) {
                        error[key] = intl.formatMessage({ id: "lastNameInvalidError" });
                        isValid = false;
                    }
                }
            }
        });
        if (!isValid) {
            updateRecoilState("retrieveFormAtom", {
                ...retrieveForm,
                error: { ...error },
            });
        }

        return isValid;
    };
    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: [],
            message: "",
            status: "fail"
        }
        try {
            const { retrieveForm, intl, isAnonymous = false, bookingIds = [] } = this.params!
            if (this.isFormValid(retrieveForm, intl)) {
                retrieveBookingAPICallAction.setParams({
                    bookingReference: retrieveForm.value.bookingReference.trim(),
                    lastName: retrieveForm.value.lastName.trim(),
                    isAnonymous,
                    bookingIds
                })
                await retrieveBookingAPICallAction.execute();
                if (isActionRunSuccessfully(retrieveBookingAPICallAction)) {
                    const result = retrieveBookingAPICallAction.result!
                    actionResult = result                    
                    if (result?.status === "success") {
                        updateRecoilState("isRetrieveModalOpenAtom", false)
                        if (!actionResult.data.alreadyExists) {
                            showNotification(
                                "success",
                                intl.formatMessage({ id: "addedSuccessfulText" }),
                                intl.formatMessage({ id: "retrieveAddedSuccessText" }),
                                4,
                                "retrieve-success" // Custom class                
                            );
                        }

                        updateRecoilState("retrieveFormAtom", {
                            value: { bookingReference: "", lastName: "" },
                            error: { bookingReference: "", lastName: "" },
                        });
                    } else {
                        if (result?.data?.isPastBooking) {
                            updateRecoilState("retrieveFormAtom", {
                                ...retrieveForm,
                                error: { bookingReference: getTranslatedMessage("pastBookingRetrieve"), lastName: "" },
                            });
                        } else {
                            updateRecoilState("retrieveFormAtom", {
                                ...retrieveForm,
                                error: { bookingReference: getTranslatedMessage("bookingReferenceNotMatch"), lastName: "" },
                            });
                        }
                    }
                } else {
                    // showNotification(
                    //     "error",
                    //     "Bookings with given information don't exist",
                    //     "",
                    //     4
                    // );
                }

            }
        } catch (error) {
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}

export const retrieveBookingAction = new RetrieveBookingAction()